import css from "styled-jsx/css";
import Colors from "styles/colors";
import { HEADER_DESKTOP_MENU_MID_WIDTH, MD_DESKTOP_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .header-menu-section-component {
    height: 100%;

    .header-menu-section-title {
      color: ${Colors.asphalt};
      font-weight: 300;
      font-size: 0.8125rem;
      display: flex;
      align-items: center;
      position: relative;
      &.with-underline {
        font-size: 1rem;
        margin-left: 8px;
        &:after {
          content: "";
          background: ${Colors.mud};
          opacity: 0.1;
          top: 24px;
          display: block;
          position: absolute;
          height: 1px;
          width: calc(100% - 20px);
          margin-left: -8px;
        }
      }
      .header-menu-section-title-image {
        height: 24px;
        display: flex;
      }
      svg {
        margin-right: 8px;
        stroke: ${Colors.asphalt};
      }
    }
    .header-menu-section-items-wrapper {
      margin: 20px 0;

      display: grid;
      grid-auto-flow: column;
      grid-template-rows: repeat(var(--max-number-of-items-in-column), auto);
    }
    .header-menu-see-more-wrapper {
      margin-bottom: 16px;

      .secondary-button {
        .secondary-button-text {
          font-size: 0.8125rem;
        }
      }
    }
  }
`;
